import createReducer, { mergeById, createCollectionStatusReducer } from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_CATEGORY_SUCCESS]: mergeById,
    [ActionTypes.FETCH_CATEGORIES_SUCCESS]: (state, { payload }) =>
      payload.reduce((map, cat) => ({ ...map, [cat.id]: cat }), state)
  }
);

const status = createCollectionStatusReducer(
  ActionTypes.FETCH_CATEGORY_SUCCESS,
  ActionTypes.FETCH_CATEGORY_ERROR
);

const category = createReducer(
  {},
  {
    [ActionTypes.FETCH_CATEGORY_FROM_KEY_SUCCESS]: (state, { payload }) => payload
  }
);

const suggestionsList = createReducer(null, {
  [ActionTypes.FETCH_CATEGORY_SUGGESTIONS_SUCCESS]: (state, { payload }) => payload
});

const suggestionsStatus = createCollectionStatusReducer(
  ActionTypes.FETCH_CATEGORY_SUGGESTIONS_SUCCESS,
  ActionTypes.FETCH_CATEGORY_SUGGESTIONS_ERROR
);

export default combineReducers({
  list,
  status,
  category,
  suggestionsList,
  suggestionsStatus
});
